// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"771ba055","453":"7818c62a"}[chunkId] + ".chunk.js";
};